import React from 'react'
import { Button, Header, Icon, Modal, Input, Loader } from 'semantic-ui-react'
import { SemanticButton } from '../styled'
import { useState, useEffect, useCallback } from "react";
import swal from "sweetalert";
import { local, producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs";
import Loading from "../../../../components/Loading";


function ModalTransfer(props) {
  const [alunos, setAlunos] = useState([]);
  const [open, setOpen] = React.useState(false)
  const [senderEmail, setSenderEmail] = React.useState()
  const [receiverEmail, setReceiverEmail] = React.useState('')
  const [loading, setLoading] = React.useState(false)

  useEffect(() => {
    setSenderEmail(props.email)
  }, [props])


  const transferAluno = async () => {
    swal(
      'Transferência de conta',
      'Deseja realmente transferir  essa conta?',
      'error',
      {
        closeOnClickOutside: false,
        closeOnEsc: false,
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: false,
            visible: true,
            className: '',
            closeModal: true
          },
          confirm: {
            text: 'Confirmar',
            value: true,
            visible: true,
            className: '',
            closeModal: true
          }
        }
      }
    )
      .then(async value => {
        if (value) {
          setLoading(true)
          try {
            await api.put(`/admin/transfer-alunos/`, { senderEmail, receiverEmail }, {
              headers: {
                'Content-type': 'application/json',
                access_token: `voitto-token ${localStorage.getItem(
                  "oauth_token"
                )}`
              }
            }).then(res => {
              setLoading(false)
              swal(
                'Transferência de conta',
                'Conta transferida com sucesso!',
                'success'
              )
              setOpen(false)
            })
            await systemLogs("alunos", `transferiu a conta do aluno de id=${senderEmail} para ${receiverEmail}`);

          } catch (err) {
            setLoading(false)
            return err;
          }
        } else {
          return;
        }
      });
  }

  return (
    <Modal
      closeIcon
      open={open}
      trigger={<SemanticButton icon="exchange"
      /*  onClick={(e) => transferAluno(props.email)}  */
      />}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    >

      <Header icon='archive' content='Transferencia de conta' />
      <Modal.Content>
        {loading ? (
          <div>
            <Loading msg='Carregando...' />
          </div>
        ) : (
          <>
            <Input icon value={senderEmail}
              onChange={(e) => setSenderEmail(e.target.value)}>
              <input />
              <Icon name='at' />
            </Input>
            <br />
            <br />
            <Input iconPosition='left' placeholder='Email'
              onChange={(e) => setReceiverEmail(e.target.value)}
              onKeyUp={(e) => e.key === "Enter" && transferAluno()}>
              <Icon name='at' />
              <input />
            </Input>
          </>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button color='red' onClick={() => transferAluno(false)}>
          <Icon name='remove' /> No
        </Button>
        <Button color='green' onClick={() => transferAluno(true)}>
          <Icon name='checkmark' /> TransferirConta
        </Button>
      </Modal.Actions>


    </Modal>
  )
}

export default ModalTransfer;
